import React from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

function SlideLeftRight({ appear, children }) {
  return (
    <CSSTransitionGroup
      transitionName="animation__slide-right"
      transitionAppear={appear}
      transitionAppearTimeout={350}
      transitionEnterTimeout={350}
      transitionLeaveTimeout={420}
    >
      {children}
    </CSSTransitionGroup>
  )
}

export default SlideLeftRight
